var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { html, LitElement } from 'lit';
import { helper } from "../../common/helper";
import css from './style.pcss';
import { detect } from "../../common/detect";
import LogoImage from "../../common/images/logo_today-radio.svg";
import PlayIcon from "../../common/images/play_icon.svg";
import CurrentBgImage from "./images/current_bg.png";
import HomeBgImage from "./images/bg_home.png";
var RTLTodayRadioOnair = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLTodayRadioOnair, _LitElement);
  function RTLTodayRadioOnair() {
    var _this;
    _classCallCheck(this, RTLTodayRadioOnair);
    _this = _callSuper(this, RTLTodayRadioOnair);
    _this.type = 'default';
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 60000);
    return _this;
  }
  _createClass(RTLTodayRadioOnair, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLTodayRadioOnair.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.apiUrl = 'https://api-gate.rtl.lu/on-air/rtltodayradio/show';
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      }).catch(function (error) {
        if (this.interval) clearInterval(this.interval);
        console.log('ERROR: ' + error.message);
      }.bind(this));
    }
  }, {
    key: "_renderCurrent",
    value: function _renderCurrent() {
      if (this.data === undefined) return html(_t || (_t = _`Loading...`));
      if (this.data.error) html(_t2 || (_t2 = _``));
      var current = this.data;
      return html(_t3 || (_t3 = _`
            <div class="rto-current">
                <div class="rto-current__image">
                    <img src="${0}" alt="${0}" />
                </div>
                <div class="rto-current__show">
                    <h3>${0}</h3>
                    ${0} - ${0}
                </div>
                <div class="schedule-button" @click="${0}"><span>AUDIO LIVE</span></div>
            </div>
        `), current.crew.image, current.crew.name, current.show.name, helper.time2eng(current.start_time), helper.time2eng(current.end_time), this._openPlayer);
    }
  }, {
    key: "_renderCurrentAside",
    value: function _renderCurrentAside() {
      if (this.data === undefined) return html(_t4 || (_t4 = _`Loading...`));
      if (this.data.error) html(_t5 || (_t5 = _``));
      var current = this.data;

      //console.log(current);

      return html(_t6 || (_t6 = _`
            <div class="rto-current-aside">
                <div class="rto-current-aside__link" @click="${0}">
                    <img src="${0}" alt="RTL Today Radio" class="rto-current-aside__logo" />
                    <div class="rto-current-aside__image">
                        <img src="${0}" alt="${0}" />
                    </div>
                    <div class="rto-current-aside__live" style="background-image: url('${0}');"><span>Listen</span></div>
                    <div class="rto-current-aside-show">
                        <div class="rto-current-aside-show__name">${0}</div>
                        <div class="rto-current-aside-show__timeslot">${0} - ${0}</div>
                    </div>
                </div>
                <div class="rto-current-aside__more">
                    <div class="rto-current-aside__more-button" @click="${0}">
                        <div class="rto-current-aside__more-plus">+</div>
                        Radio
                    </div>
                    ${0}
                </div>
            </div>
        `), this._openPlayer, LogoImage, current.crew.imageTransparent, current.crew.name, PlayIcon, current.show.name, helper.time2eng(current.start_time), helper.time2eng(current.end_time), this._openRadioPage, current.show.logoImg ? html(_t7 || (_t7 = _`
                        <div class="rto-current-aside__partner">
                            Presented By
                            <div class="rto-current-aside__partner-logo"><a href="${0}" target="_blank"><img src="${0}" alt="Partner" /></div></a>
                        </div>
                    `), this.data.show.logoUrl, current.show.logoImg) : '');
    }
  }, {
    key: "_openPlayer",
    value: function _openPlayer() {
      var isSafari = detect.isSafari();
      if (window.rtlsites.config.isApp) {
        //window.location.href = 'rtltoday://toggle-radio';
        window.location.href = 'rtltoday://audiostream/https://stream.rtl.lu/live/hls/radio/rtltodayradio';
      } else {
        if (isSafari) {
          window.open('/radio-player', 'RTL Today Radio Player', "width=760,height=488,toolbar=no,resizable=1");
        } else {
          window.open('/radio-player', 'RTL Today Radio Player', "width=760,height=459,toolbar=no,resizable=1");
        }
      }
    }
  }, {
    key: "_openRadioPage",
    value: function _openRadioPage() {
      window.location.href = '/radio';
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      return html(_t8 || (_t8 = _`
            <style>${0}</style>
            <div class="rto-onair">
                <div class="rto-onair__top" style="background: transparent url('${0}') top left no-repeat;">
                    <div class="rto-onair__current">
                        ${0}
                    </div>
                    <div class="rto-onair__stream">
                        <rtl-player poster="https://stream.rtl.lu/data/live/thumbnails/stream5.jpg"
                                    type="live"
                                    language="en"
                                    contentid="urn:rtl:livestream:rtltoday"
                                    channelname="rtltodayradio"
                                    hls="https://stream.rtl.lu/live/hls/rtltodayradio"></rtl-player>
                    </div>
                </div>

                <div class="rto-onair__playlist">
                    <rtl-today-radio-playlist limit="3"></rtl-today-radio-playlist>
                </div>
            </div>
        `), css, CurrentBgImage, this._renderCurrent());
    }
  }, {
    key: "_renderAside",
    value: function _renderAside() {
      return html(_t9 || (_t9 = _`
            <div class="rto-onair-aside" style="background-image: url('${0}');">
                <div class="rto-onair-aside__top">
                    <div class="rto-onair__current">
                        ${0}
                    </div>
                </div>
            </div>
        `), HomeBgImage, this._renderCurrentAside());
    }
  }, {
    key: "render",
    value: function render() {
      var output;
      if (this.type === 'aside') output = this._renderAside();else output = this._renderDefault();
      return html(_t10 || (_t10 = _`
            <style>${0}</style>
            ${0}
        `), css, output);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLTodayRadioOnair;
}(LitElement);
export { RTLTodayRadioOnair as default };
window.customElements.define('rtl-today-radio-onair', RTLTodayRadioOnair);